import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  CircularProgress,
} from "@mui/material";

import { useCookies } from "react-cookie";

import { getPdf } from "../api/serverApi";

const FileDocumentViewModal = ({
  open,
  onClose,
  title,
  sharepointFileId,
  accessToken,
  fileType = "pdf",
}) => {
  const [cookies] = useCookies(["permissions"]);
  // Print/download toolbar only for Admin; hidden for all other roles
  const canDownload = cookies.permissions === "Admin";
  const [pdfUrl, setPdfUrl] = useState("");
  const [textContent, setTextContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || !sharepointFileId || !accessToken) {
      return;
    }

    const loadDocument = async () => {
      try {
        setLoading(true);
        setError("");
        setPdfUrl("");
        setTextContent("");

        console.log("========== VIEW DOCUMENT ==========");
        console.log("Title:", title);
        console.log("SharePoint File ID:", sharepointFileId);
        console.log("File Type:", fileType);

        // =====================================================
        // SUMMARY - TXT FILE
        // =====================================================
        if (fileType === "txt") {
          const response = await fetch(
            `https://land-documents-dev-ejcuftebf0dzg0e8.centralindia-01.azurewebsites.net/api/proxy-file?document_id=${encodeURIComponent(
              sharepointFileId
            )}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
              credentials: "include",
            }
          );

          console.log("Summary TXT response:", response);

          if (!response.ok) {
            throw new Error(
              `Failed to load summary. Status: ${response.status}`
            );
          }

          const text = await response.text();

          console.log("Summary text:", text);

          setTextContent(text);
          return;
        }

        // =====================================================
        // TRANSLATION - PDF FILE
        // =====================================================
        const response = await getPdf(
          sharepointFileId,
          accessToken
        );

        console.log("PDF response:", response);

        if (!response?.pdfUrl) {
          throw new Error(
            "PDF URL was not generated."
          );
        }

        setPdfUrl(response.pdfUrl);
      } catch (err) {
        console.error(
          "Error loading document:",
          err
        );

        setError(
          err?.message ||
            "Failed to load document."
        );
      } finally {
        setLoading(false);
      }
    };

    loadDocument();
  }, [
    open,
    sharepointFileId,
    accessToken,
    title,
    fileType,
  ]);

  const handleClose = () => {
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
    }

    setPdfUrl("");
    setTextContent("");
    setError("");

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 600,
        }}
      >
        {title}

        <IconButton onClick={handleClose}>
          ✕
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          height: "80vh",
          padding: 0,
          overflow: "hidden",
        }}
      >
        {loading ? (
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </div>
        ) : error ? (
          <div
            style={{
              padding: "30px",
              color: "red",
            }}
          >
            {error}
          </div>
        ) : fileType === "txt" ? (
          <div
            style={{
              height: "100%",
              overflowY: "auto",
              padding: "30px",
              backgroundColor: "#fff",
              whiteSpace: "pre-wrap",
              fontFamily:
                "Arial, sans-serif",
              fontSize: "15px",
              lineHeight: "1.6",
            }}
          >
            {textContent}
          </div>
        ) : pdfUrl ? (
          <iframe
            src={`${pdfUrl}#toolbar=${canDownload ? 1 : 0}`}
            onContextMenu={(e) => e.preventDefault()}

            title={title}
            width="100%"
            height="100%"
            style={{
              border: "none",
            }}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default FileDocumentViewModal;